<template>
  <div>
    <el-form>
      <el-row :gutter="50">
        <el-col :span="24">
          <div class="form-group">
            <el-form-item label="Content">
              <el-input type="textarea" autosize v-model="field.content" placeholder="Enter content"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name:"templates-formComponents-Paragraph",
  props: ["field"],
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss">
</style>